/* Enlarge supporting product photographs while retaining a normal image-link fallback. */
(() => {
  if (window.revoSupportingImagesReady) return;
  window.revoSupportingImagesReady = true;
  let dialog;
  let image;
  let canvas;
  let zoom;
  let opener;
  let previousOverflow;
  function createViewer() {
    dialog = document.createElement('dialog');
    dialog.className = 'revo-image-viewer';
    dialog.setAttribute('aria-label', 'Expanded product photo');
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'revo-image-viewer-close';
    close.textContent = 'Close';
    close.autofocus = true;
    zoom = document.createElement('button');
    zoom.type = 'button';
    zoom.className = 'revo-image-viewer-zoom';
    zoom.textContent = 'Zoom in';
    zoom.setAttribute('aria-pressed', 'false');
    const controls = document.createElement('div');
    controls.className = 'revo-image-viewer-controls';
    controls.append(zoom, close);
    image = document.createElement('img');
    canvas = document.createElement('div');
    canvas.className = 'revo-image-viewer-canvas';
    canvas.tabIndex = 0;
    canvas.setAttribute('role', 'region');
    canvas.setAttribute('aria-label', 'Product photo. Scroll to inspect when zoomed.');
    canvas.append(image);
    dialog.append(controls, canvas);
    document.body.append(dialog);
    close.addEventListener('click', () => dialog.close());
    zoom.addEventListener('click', async () => {
      try { await image.decode(); } catch { return; }
      if (!dialog.open) return;
      const enlarged = zoom.getAttribute('aria-pressed') !== 'true';
      zoom.setAttribute('aria-pressed', String(enlarged));
      zoom.textContent = enlarged ? 'Zoom out' : 'Zoom in';
      canvas.classList.toggle('is-zoomed', enlarged);
      image.style.width = enlarged ? Math.max(image.naturalWidth, canvas.clientWidth * 2) + 'px' : '';
      canvas.scrollLeft = enlarged ? (canvas.scrollWidth - canvas.clientWidth) / 2 : 0;
      canvas.scrollTop = enlarged ? (canvas.scrollHeight - canvas.clientHeight) / 2 : 0;
      if (enlarged) canvas.focus({preventScroll: true});
    });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'Tab') {
        event.preventDefault();
        const controls = [zoom, close, canvas];
        const next = (controls.indexOf(document.activeElement) + (event.shiftKey ? -1 : 1) + controls.length) % controls.length;
        controls[next].focus();
      }
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.body.style.overflow = previousOverflow;
      image.removeAttribute('src');
      if (opener?.isConnected) opener.focus({preventScroll: true});
    });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest?.('[data-revo-image-expand]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || typeof HTMLDialogElement === 'undefined') return;
    const source = new URL(link.href, location.href);
    if (source.origin !== location.origin && source.hostname !== 'cdn.shopify.com') return;
    if (!dialog) createViewer();
    if (dialog.open) return;
    event.preventDefault();
    opener = link;
    image.alt = link.querySelector('img').alt;
    image.src = source.href;
    image.style.width = '';
    canvas.classList.remove('is-zoomed');
    canvas.scrollTop = canvas.scrollLeft = 0;
    zoom.textContent = 'Zoom in';
    zoom.setAttribute('aria-pressed', 'false');
    previousOverflow = document.body.style.overflow;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
  });
})();
